<template>
<div class="credit-card-link">
	&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
	<form method="POST" style="display:inline;">
	    <input type="hidden" name="iMethodId" value="4" />
	    <button class="link-E font-E2 shadowed-text link-button" >Charge to credit card</button>
	</form>
</div>
</template>

<script>

export default {
  name: "CreditCardLink"
}

</script>

<style scoped>

</style>